import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { rootRoute } from '@/tenant/identities/root'

import { SearchSchema, listIdentities } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const listRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/list',
    component: lazyRouteComponent(() => import('./List'), 'List'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: ({ deps, abortController }) => listIdentities(deps, 0, abortController),
})
